/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsThreadColor,
    MelcoModelsThreadColorFromJSON,
    MelcoModelsThreadColorFromJSONTyped,
    MelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsThread
 */
export interface MelcoModelsThread {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    code?: string | null;
    /**
     * 
     * @type {MelcoModelsThreadColor}
     * @memberof MelcoModelsThread
     */
    color?: MelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MelcoModelsThread
     */
    weight_list?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThread
     */
    product_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsThread
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsThread
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsThread
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsThread
     */
    publish_date?: Date | null;
}

export function MelcoModelsThreadFromJSON(json: any): MelcoModelsThread {
    return MelcoModelsThreadFromJSONTyped(json, false);
}

export function MelcoModelsThreadFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsThread {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : MelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight_list': !exists(json, 'weight_list') ? undefined : json['weight_list'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
    };
}

export function MelcoModelsThreadToJSON(value?: MelcoModelsThread | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': MelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight_list': value.weight_list,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'product_id': value.product_id,
        'product_name': value.product_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'publish_state': value.publish_state,
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
    };
}


